'use client'

import { useTheme } from 'next-themes'
import { Button } from '@/components/ui/button'
import { useEffect, useState } from 'react'
import { isDarkTheme } from '@/lib/daisy-themes'

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])

  if (!mounted) return <div className="h-9 w-9" />

  const currentIsDark = theme ? isDarkTheme(theme) : false
  const next = currentIsDark ? 'light' : 'dark'
  const label = currentIsDark ? '☀️' : '🌙'

  return (
    <Button variant="ghost" size="icon" onClick={() => setTheme(next)} aria-label="Toggle theme">
      <span className="text-base">{label}</span>
    </Button>
  )
}
